import { createGlobalStyle } from 'styled-components';
import Black from '../assets/fonts/ExoBNNVARA-Black.woff';
import Bold from '../assets/fonts/ExoBNNVARA-Bold.woff';
import ExtraBold from '../assets/fonts/ExoBNNVARA-ExtraBold.woff';
import Italic from '../assets/fonts/ExoBNNVARA-Italic.woff';
import Medium from '../assets/fonts/ExoBNNVARA-Medium.woff';
import Regular from '../assets/fonts/ExoBNNVARA-Regular.woff';
export const Fonts = createGlobalStyle`
  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:normal;
    font-weight:400;
    src:local('Exo BNNVARA Regular'), url(${Regular})}

  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:italic;
    font-weight:400;
    src:local('Exo BNNVARA Italic'), url(${Italic})}

  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:normal;
    font-weight:500;
    src:local('Exo BNNVARA Medium'), url(${Medium})}

  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:normal;
    font-weight:700;
    src:local('Exo BNNVARA Bold'), url(${Bold})}

  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:normal;
    font-weight:800;
    src:local('Exo BNNVARA Extra Bold'), url(${ExtraBold})}

  @font-face{
    font-family:"Exo BNNVARA";
    font-display: swap;
    font-style:normal;
    font-weight:900;
    src:local('Exo BNNVARA Black'), url(${Black})}
`;
const colors = {
  base: {
    white: '#FFFFFF',
    black: '#101010',
    blue: '#01BAEF',
    darkBlue: '#0772E6',
    red: '#cd0000',
    gray: '#EFEFEF'
  },
  primary: {
    light: '#FF2222',
    lighter: '#FF4D4D',
    main: '#E60000',
    dark: '#CD0000',
    contrastText: '#FFFFFF',
    disabled: '#777777'
  },
  secondary: {
    light: '#666666',
    main: '#222222',
    dark: '#101010',
    gray: '#999999',
    contrastText: '#FFFFFF'
  },
  tertiary: {
    light: '#F5F5F5',
    main: '#EFEFEF',
    dark: '#BBBBBB'
  },
  success: {
    main: '#0C7723'
  },
  error: {
    main: '#E60000'
  },
  warning: {
    main: '#FFB400'
  },
  gradient: {
    primary: 'linear-gradient(to right, rgba(0,0,0,0.3) 0%,rgba(0,0,0,0) 34%,rgba(0,0,0,0) 64%,rgba(0,0,0,0.3) 100%)'
  }
};
const theme = {
  bnnvara: {
    name: 'BNNVARA',
    fonts: {
      primary: "'Exo BNNVARA', Verdana, sans-serif",
      secondary: "'Exo 2', Helvetica, sans-serif"
    },

    /**
     * We also pass colors as a key variable, to assure it works with styled systems.
     * See documentation: https://styled-system.com/api/
     */
    colors,
    ...colors
  },
  grayscale: {
    name: 'Grayscale',
    fonts: {
      primary: "'Exo BNNVARA', Verdana, sans-serif",
      secondary: "'Exo 2', Helvetica, sans-serif"
    },
    base: {
      white: '#FFFFFF',
      black: '#101010',
      blue: '#cccccc'
    },
    primary: {
      light: '#999999',
      main: '#888888',
      dark: '#777777',
      contrastText: '#FFFFFF'
    },
    secondary: {
      light: '#666666',
      main: '#222222',
      dark: '#101010',
      contrastText: '#FFFFFF'
    },
    tertiary: {
      light: '#F5F5F5',
      main: '#EFEFEF',
      dark: '#BBBBBB'
    },
    success: {
      main: '#888888'
    },
    error: {
      main: '#777777'
    },
    gradient: {
      primary: 'linear-gradient(to right, rgba(0,0,0,0.3) 0%,rgba(0,0,0,0) 34%,rgba(0,0,0,0) 64%,rgba(0,0,0,0.3) 100%)'
    }
  }
};
export default theme;